module.exports = __webpack_public_path__ + "static/media/tourne-ta-chance.8887a6ac.png";